import Logger from 'nordic/logger';
import { misc } from '@credits-utils/constants';
import { setTags, errorTags } from './helpers';

const { LOGGER_TRANSACTION, LOGGER_EXECUTION } = misc;

class LoggerCustom {
  constructor({ context, req, method }) {
    this.logger = Logger();
    this.tags = setTags({
      req,
      context,
      method,
    });
  }

  started(props) {
    this.logger.info(LOGGER_TRANSACTION.STARTED, {
      execution: LOGGER_EXECUTION.STARTED,
      ...this.tags,
      ...props,
    });
  }

  success(props) {
    this.logger.info(LOGGER_TRANSACTION.SUCCEEDED, {
      execution: LOGGER_EXECUTION.SUCCEEDED,
      ...this.tags,
      ...props,
    });
  }

  error({ err }, props) {
    this.logger.error(LOGGER_TRANSACTION.FAILED, {
      execution: LOGGER_EXECUTION.FAILED,
      ...this.tags,
      ...errorTags({ err }),
      ...props,
    });
  }
}

export default LoggerCustom;
